import { ToEntity } from 'core/common/mappers';
import { NatalChart, NatalChartData, PlanetNames, SignsInfo, ZodiacSignDegrees } from '../entities';
import { NatalChartDto } from '../services/natalChart/dto';

export class NatalChartMapper implements ToEntity<NatalChart, NatalChartDto> {
  toEntity(dto: NatalChartDto): NatalChart {
    const natalChartData = this.mapNatalChartDtoToNatalChartData(dto);
    const signsInfo = this.mapNatalChartDtoToSignsInfo(dto);

    return {
      natalChartData,
      signsInfo,
    };
  }

  private mapNatalChartDtoToSignsInfo(dto: NatalChartDto): SignsInfo {
    const venusSign = dto.planets.find((planet) => planet.name === 'venus');
    const seventhHouseSign = dto.houses.find((house) => house.number === 7);
    const marsSign = dto.planets.find((planet) => planet.name === 'mars');
    const fifthHouseSign = dto.houses.find((house) => house.number === 5);
    const mercurySign = dto.planets.find((planet) => planet.name === 'mercury');
    const tenthHouseSign = dto.houses.find((house) => house.number === 10);
    const secondHouseSign = dto.houses.find((house) => house.number === 2);

    return {
      sunSign: dto.sun_sign,
      moonSign: dto.moon_sign,
      ascendantSign: dto.ascendant,
      venusSign: venusSign?.sign || '',
      seventhHouseSign: seventhHouseSign?.sign || '',
      marsSign: marsSign?.sign || '',
      fifthHouseSign: fifthHouseSign?.sign || '',
      mercurySign: mercurySign?.sign || '',
      tenthHouseSign: tenthHouseSign?.sign || '',
      secondHouseSign: secondHouseSign?.sign || '',
    };
  }

  private mapNatalChartDtoToNatalChartData(dto: NatalChartDto): NatalChartData {
    const astroData: Record<string, number[]> = {};
    const planetsInHouse: Record<string, number> = {};

    dto.planets.forEach((planet) => {
      const astroChartName = PlanetNames[planet.name];
      if (!astroChartName) {
        return;
      }

      const signDegree = ZodiacSignDegrees[planet.sign] || 0;
      const absoluteDegree = signDegree + planet.position;

      astroData[astroChartName] = [absoluteDegree];
      planetsInHouse[planet.name] = planet.house.number;
    });

    const cusps: number[] = [];

    const sortedHouses = [...dto.houses].sort((a, b) => a.number - b.number);

    sortedHouses.forEach((house) => {
      const signDegree = ZodiacSignDegrees[house.sign] || 0;
      const absoluteDegree = signDegree + house.position;
      cusps.push(absoluteDegree);
    });

    return {
      astroData,
      cusps,
      planetsInHouse,
    };
  }
}
